import { render, staticRenderFns } from "./activitydetails.vue?vue&type=template&id=4b90c8ea&scoped=true&"
import script from "./activitydetails.vue?vue&type=script&lang=js&"
export * from "./activitydetails.vue?vue&type=script&lang=js&"
import style0 from "./activitydetails.vue?vue&type=style&index=0&id=4b90c8ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b90c8ea",
  null
  
)

export default component.exports